class ApiError extends Error {
    constructor(data) {
        super(data.message);

        this.status = data.status;
        this.errorCode = data.errorcode;
    }
}

export const handleResult = result => {
    const { data, status, ...other } = result;
    if (status === 200) {
        // if (data.status === 1)
            return data;

        // throw new ApiError(data);
    }

    throw new Error({ ...other, status });
}